import { MouseEventHandler, ReactNode } from 'react';
import { Chip } from '@mui/material';

interface IProps {
  label: ReactNode;
  size?: 'small' | 'medium';
  color?: 'warning' | 'disabled' | 'lightBlue' | 'lightGreen' | 'orange';
  onClick?: MouseEventHandler<HTMLDivElement>;
  onDelete?: (event: any) => void;
}

export default function CasChip({
  label,
  size = 'medium',
  color = 'warning',
  onClick,
  onDelete,
}: IProps) {
  const sizeMap = {
    small: {
      height: '16px',
      fontSize: '11px',
    },
    medium: {
      fontSize: '12px',
    },
  };

  const bgColor = {
    warning: '#fbf3c0', // light yellow
    disabled: '#EBEBEB', // light gray
    lightBlue: '#cfe2f3', // light blue
    // Same hue as the "this filter has a value" input background
    // (.has-value in CasTable/_internal/CasTableToolbar.scss), opaque so it
    // reads as a filled chip. Used for active-filter chips, which keeps them
    // visually distinct from data chips in table cells.
    lightGreen: '#e4fbea',
    // An active-filter chip that must not blend in with the others (a filter's `chipColor`).
    orange: '#ffa500',
  };

  const backgroundColor = color ? bgColor[color] : undefined;

  return (
    <Chip
      label={label}
      size="small"
      onClick={onClick}
      onDelete={onDelete}
      sx={{
        ...sizeMap[size],
        color: 'black',
        backgroundColor,
        '&:hover': {
          backgroundColor, // prevent hover color change
        },
        '& .MuiChip-label': {
          paddingLeft: '8px',
          paddingRight: '8px',
        },
        '& .MuiChip-deleteIcon': {
          color: 'rgba(0, 0, 0, 0.4)',
          '&:hover': {
            color: 'rgba(0, 0, 0, 0.7)',
          },
        },
      }}
    />
  );
}
